(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ehs-dealer-locator"] && !Shopify.designMode) return;
  try {
    
  /*
   * WI-63: "Contact this dealer". One delegated listener, so the buttons work in the cards, in the
   * nearby list (cards are moved there) and in the map popups (links are cloned there). The dialog
   * receives only the dealer code and name. After Shopify's redirect back from a post
   * (contact_posted=true, or a form with errors) the dialog reopens to show the outcome.
   */
  const ehsDealerContactInit = () => {
    const dialog = document.querySelector('[data-ehs-contact-dialog]');
    if (!dialog || typeof dialog.showModal !== 'function') return; // no dialog support: the link falls back to the contact page

    const codeInput = dialog.querySelector('[data-ehs-contact-code]');
    const dealerInput = dialog.querySelector('[data-ehs-contact-dealer]');
    const nameSlot = dialog.querySelector('[data-ehs-contact-name]');
    const storeKey = 'ehs-dealer-contact';

    const open = (code, name) => {
      codeInput.value = code || '';
      dealerInput.value = name || '';
      nameSlot.textContent = name || '';
      try { sessionStorage.setItem(storeKey, JSON.stringify({ code, name })); } catch (e) { /* storage blocked: fine */ }
      dialog.showModal();
    };

    document.addEventListener('click', (e) => {
      const btn = e.target.closest('[data-ehs-contact]');
      if (!btn) return;
      e.preventDefault();
      open(btn.getAttribute('data-dealer-code'), btn.getAttribute('data-dealer-name'));
    });

    dialog.querySelector('[data-ehs-contact-close]').addEventListener('click', () => dialog.close());

    // Back from Shopify's post: show the success or error message in the dialog.
    if (dialog.querySelector('[data-ehs-contact-status]')) {
      let last = {};
      try { last = JSON.parse(sessionStorage.getItem(storeKey) || '{}'); } catch (e) { last = {}; }
      codeInput.value = last.code || '';
      dealerInput.value = last.name || '';
      nameSlot.textContent = last.name || '';
      dialog.showModal();
    }
  };
  // Shopify may load section scripts before the page body is parsed: wait for it.
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', ehsDealerContactInit, { once: true });
  } else {
    ehsDealerContactInit();
  }

  customElements.define(
    'ehs-dealer-locator',
    class EhsDealerLocator extends HTMLElement {
      connectedCallback() {
        this.countrySelect = this.querySelector('[data-ehs-country]');
        this.searchInput = this.querySelector('[data-ehs-search]');
        this.countLabel = this.querySelector('[data-ehs-count]');
        this.noMatch = this.querySelector('[data-ehs-none]');
        this.groups = Array.from(this.querySelectorAll('[data-ehs-group]'));
        this.cards = Array.from(this.querySelectorAll('[data-ehs-card]'));
        this.mapEl = this.querySelector('[data-ehs-map]');
        this.mapBtn = this.querySelector('[data-ehs-show-map]');
        this.mapNote = this.querySelector('[data-ehs-map-note]');
        this.countPrefix = (this.countLabel ? this.countLabel.textContent : '')
          .replace(/\s*\d+\s*$/, '')
          .trim();
        this.showLabel = this.mapBtn ? this.mapBtn.textContent.trim() : 'Show map';
        // Was hard-coded, which left the `hide_map_label` setting doing nothing. Now wired.
        this.hideLabel = this.dataset.tHideMap || 'Hide map';
        this.markers = [];
        this.map = null;

        /* ---- WI-58: proximity search (distance, geolocation, geocoded place search) ---- */
        this.searchForm = this.querySelector('[data-ehs-search-form]');
        this.geoBtn = this.querySelector('[data-ehs-geolocate]');
        this.statusEl = this.querySelector('[data-ehs-status]');
        this.nearbyEl = this.querySelector('[data-ehs-nearby]');
        this.nearbyList = this.querySelector('[data-ehs-nearby-list]');
        this.nearbyTitle = this.querySelector('[data-ehs-nearby-title]');
        this.attribEl = this.querySelector('[data-ehs-attrib]');
        this.resetBtn = this.querySelector('[data-ehs-reset]');
        this.origin = null;
        this.originMarker = null;
        this.geoBusy = false;
        const d = this.dataset;
        this.cfg = {
          limit: parseInt(d.limit, 10) > 0 ? parseInt(d.limit, 10) : 10,
          unit: d.unit === 'mi' ? 'mi' : 'km',
          geocode: d.geocode === 'true',
          bias: (d.bias || '').trim(),
          t: {
            near: d.tNear || 'Nearest dealers to {place}',
            dist: d.tDist || '{distance} away',
            locating: d.tLocating || 'Finding your location…',
            searching: d.tSearching || 'Searching…',
            denied: d.tDenied || 'Location access was denied. Type a city or postal code instead.',
            failed: d.tFailed || 'We could not find that place. Try a city name or a full postal code.',
            attrib: d.tAttrib || 'Place search by OpenStreetMap / Nominatim.',
            here: d.tHere || 'your location'
          }
        };
        // Remember exactly where each card lives, so proximity mode is fully reversible and the
        // server-rendered country grouping is restored byte-for-byte on reset.
        // Keyed by parent list and kept in document order: a per-card nextSibling anchor is NOT
        // enough, because once sibling cards move the anchors point at relocated nodes and the
        // within-group order comes back scrambled.
        this.homes = new Map();
        this.cards.forEach((c) => {
          const parent = c.parentNode;
          if (!this.homes.has(parent)) this.homes.set(parent, []);
          this.homes.get(parent).push(c);
        });

        this.onInput = this.filter.bind(this);
        if (this.countrySelect) {
          // Picking a country is a browse action: leave proximity mode and filter normally.
          this.countrySelect.addEventListener('change', () => {
            if (this.origin) this.clearProximity(false);
            this.filter();
          });
        }
        if (this.searchInput) {
          // Typing returns to plain substring filtering; it never geocodes.
          this.searchInput.addEventListener('input', () => {
            if (this.origin) this.clearProximity(false);
            this.filter();
          });
        }
        if (this.searchForm) {
          this.searchForm.addEventListener('submit', (e) => { e.preventDefault(); this.searchNearby(); });
        }
        if (this.geoBtn) this.geoBtn.addEventListener('click', () => this.geolocate());
        if (this.resetBtn) this.resetBtn.addEventListener('click', () => this.clearProximity(true));
        if (this.mapBtn) this.mapBtn.addEventListener('click', () => this.toggleMap());

        this.mapAuto = this.dataset.mapAuto === 'true';
        this.consentCategory = this.dataset.mapConsent || 'preferences';
        this.initConsent();
        this.cards.forEach((card) => {
          card.addEventListener('click', (e) => {
            if (e.target.closest('a')) return;
            this.selectCard(card);
          });
        });
        this.filter();
      }

      disconnectedCallback() {
        if (this.countrySelect) this.countrySelect.removeEventListener('change', this.onInput);
        if (this.searchInput) this.searchInput.removeEventListener('input', this.onInput);
        // document-level, so it outlives the element unless removed -- matters in the theme editor,
        // which tears the section down and rebuilds it on every settings change.
        if (this._onConsent) {
          document.removeEventListener('visitorConsentCollected', this._onConsent);
          this._onConsent = null;
        }
      }

      filter() {
        const country = this.countrySelect ? this.countrySelect.value : '';
        const term = (this.searchInput ? this.searchInput.value : '').trim().toLowerCase();
        let visible = 0;

        this.cards.forEach((card) => {
          const group = card.getAttribute('data-ehs-country') || '';
          const isDistributor = card.getAttribute('data-ehs-type') === 'distributor';
          const countryOk = !country || group === country || isDistributor;
          const textOk = !term || (card.getAttribute('data-ehs-index') || '').indexOf(term) !== -1;
          const show = countryOk && textOk;
          card.hidden = !show;
          if (show && (!isDistributor || !country)) visible += 1;
        });

        this.groups.forEach((group) => {
          group.hidden = !group.querySelector('[data-ehs-card]:not([hidden])');
        });

        if (this.noMatch) this.noMatch.hidden = visible > 0;
        if (this.countLabel) this.countLabel.textContent = `${this.countPrefix} ${visible}`;
        if (this.map) this.syncMarkers();
      }

      /* ================= WI-58b: consent-gated map auto-load ================= */

      /**
       * The map fetches Leaflet (cdnjs) and tiles (OpenStreetMap); both receive the visitor's IP.
       * So it auto-loads ONLY where that transfer is already covered:
       *   - the visitor accepted the relevant category in Shopify's cookie banner, or
       *   - the visitor's region does not require consent, in which case Shopify's own
       *     *Allowed() methods return true on their own.
       * Everyone else keeps the coloured "Show map" button, which is an explicit, informed request.
       */
      initConsent() {
        // Explicit rather than relying on the server-rendered class: whatever state this element is
        // built from (including a theme-editor re-render of already-open markup), a map that is not
        // showing must present a coloured button.
        this.setMapBtnState(this.mapEl ? !this.mapEl.hidden && !!this.map : false);
        if (!this.mapEl || !this.mapAuto) return;
        const tryAuto = () => {
          if (this.map || !this.isConnected) return;
          if (this.consentAllows()) this.toggleMap();
        };
        // Fires when the visitor answers (or changes) the banner after page load.
        this._onConsent = tryAuto;
        document.addEventListener('visitorConsentCollected', this._onConsent);

        const api = window.Shopify && window.Shopify.customerPrivacy;
        if (api && typeof api.analyticsProcessingAllowed === 'function') { tryAuto(); return; }
        if (window.Shopify && typeof window.Shopify.loadFeatures === 'function') {
          try {
            window.Shopify.loadFeatures(
              [{ name: 'consent-tracking-api', version: '0.1' }],
              (err) => { if (!err) tryAuto(); }
            );
          } catch (e) { /* leave the button; the visitor can still load the map */ }
        }
      }

      consentAllows() {
        const api = window.Shopify && window.Shopify.customerPrivacy;
        if (!api) return false;
        const method = {
          analytics: 'analyticsProcessingAllowed',
          marketing: 'marketingAllowed',
          preferences: 'preferencesProcessingAllowed'
        }[this.consentCategory] || 'preferencesProcessingAllowed';
        if (typeof api[method] !== 'function') return false;
        try { return api[method]() === true; } catch (e) { return false; }
      }

      /** Coloured while the map is off (it is a feature button); quiet once the map is up. */
      setMapBtnState(mapVisible) {
        if (!this.mapBtn) return;
        this.mapBtn.classList.toggle('ehs-btn--primary', !mapVisible);
        this.mapBtn.classList.toggle('ehs-btn--secondary', !!mapVisible);
      }

      /* ================= WI-58 proximity ================= */

      setStatus(msg, tone) {
        if (!this.statusEl) return;
        this.statusEl.textContent = msg || '';
        this.statusEl.hidden = !msg;
        if (tone) this.statusEl.setAttribute('data-tone', tone);
        else this.statusEl.removeAttribute('data-tone');
      }

      setBusy(on) {
        this.geoBusy = !!on;
        [this.geoBtn, this.querySelector('[data-ehs-search-submit]')].forEach((b) => {
          if (b) b.disabled = !!on;
        });
      }

      /** Great-circle distance in km. */
      static km(a, b) {
        const R = 6371.0088, rad = (x) => (x * Math.PI) / 180;
        const dLat = rad(b.lat - a.lat), dLng = rad(b.lng - a.lng);
        const s =
          Math.sin(dLat / 2) ** 2 +
          Math.cos(rad(a.lat)) * Math.cos(rad(b.lat)) * Math.sin(dLng / 2) ** 2;
        return 2 * R * Math.asin(Math.min(1, Math.sqrt(s)));
      }

      coordOf(card) {
        const lat = parseFloat(card.getAttribute('data-ehs-lat'));
        const lng = parseFloat(card.getAttribute('data-ehs-lng'));
        return Number.isFinite(lat) && Number.isFinite(lng) ? { lat, lng } : null;
      }

      formatDistance(km) {
        const v = this.cfg.unit === 'mi' ? km * 0.621371 : km;
        const digits = v < 10 ? 1 : 0;
        let n;
        try {
          n = new Intl.NumberFormat(document.documentElement.lang || undefined, {
            maximumFractionDigits: digits, minimumFractionDigits: 0
          }).format(v);
        } catch (e) { n = v.toFixed(digits); }
        return `${n} ${this.cfg.unit}`;
      }

      /** Rank every dealer that has coordinates, nearest first. */
      rank(origin) {
        return this.cards
          .map((card) => {
            const c = this.coordOf(card);
            return c ? { card, km: EhsDealerLocator.km(origin, c) } : null;
          })
          .filter(Boolean)
          .sort((a, b) => a.km - b.km);
      }

      /**
       * Move the nearest N cards into the flat "nearby" list, hide the country groups, and stamp a
       * distance on each. The original DOM is restored verbatim by clearProximity().
       */
      applyProximity(origin, placeLabel, showAttrib) {
        const ranked = this.rank(origin).slice(0, this.cfg.limit);
        if (!ranked.length) { this.setStatus(this.cfg.t.failed, 'error'); return; }

        this.origin = origin;
        this.clearDistanceBadges();

        this.cards.forEach((c) => { c.hidden = true; });
        this.groups.forEach((g) => { g.hidden = true; });

        const frag = document.createDocumentFragment();
        ranked.forEach(({ card, km }) => {
          const badge = document.createElement('p');
          badge.className = 'ehs-dealer__distance';
          badge.setAttribute('data-ehs-distance', '');
          badge.textContent = this.cfg.t.dist.replace('{distance}', this.formatDistance(km));
          card.insertBefore(badge, card.firstChild);
          card.hidden = false;
          card._km = km;
          frag.appendChild(card);
        });

        if (this.nearbyList) { this.nearbyList.textContent = ''; this.nearbyList.appendChild(frag); }
        if (this.nearbyTitle) {
          this.nearbyTitle.textContent = this.cfg.t.near.replace('{place}', placeLabel || '');
        }
        if (this.attribEl) {
          this.attribEl.textContent = showAttrib ? this.cfg.t.attrib : '';
          this.attribEl.hidden = !showAttrib;
        }
        if (this.nearbyEl) this.nearbyEl.hidden = false;
        if (this.noMatch) this.noMatch.hidden = true;
        if (this.countLabel) this.countLabel.textContent = `${this.countPrefix} ${ranked.length}`;
        this.setStatus('');
        if (this.map) this.syncMarkers();
        if (this.nearbyEl && this.nearbyEl.scrollIntoView) {
          this.nearbyEl.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
        }
      }

      clearDistanceBadges() {
        this.querySelectorAll('[data-ehs-distance]').forEach((n) => n.remove());
        this.cards.forEach((c) => { delete c._km; });
      }

      /** Put every card back exactly where the server rendered it. */
      clearProximity(alsoClearInput) {
        this.origin = null;
        this.clearDistanceBadges();
        // Re-append each list's cards in their original order; that restores the document exactly.
        this.homes.forEach((cards, parent) => {
          cards.forEach((c) => parent.appendChild(c));
        });
        if (this.nearbyList) this.nearbyList.textContent = '';
        if (this.nearbyEl) this.nearbyEl.hidden = true;
        if (this.attribEl) { this.attribEl.hidden = true; this.attribEl.textContent = ''; }
        if (alsoClearInput && this.searchInput) this.searchInput.value = '';
        this.removeOriginMarker();
        this.setStatus('');
        this.filter();
      }

      geolocate() {
        if (this.geoBusy) return;
        if (!('geolocation' in navigator)) { this.setStatus(this.cfg.t.denied, 'error'); return; }
        this.setBusy(true);
        this.setStatus(this.cfg.t.locating);
        navigator.geolocation.getCurrentPosition(
          (pos) => {
            this.setBusy(false);
            this.applyProximity(
              { lat: pos.coords.latitude, lng: pos.coords.longitude },
              this.cfg.t.here,
              false
            );
          },
          () => { this.setBusy(false); this.setStatus(this.cfg.t.denied, 'error'); },
          { enableHighAccuracy: false, timeout: 10000, maximumAge: 300000 }
        );
      }

      /**
       * Geocode the typed place through Nominatim (OpenStreetMap): keyless and free.
       * Only ever called on an explicit submit -- never per keystroke -- which is what keeps this
       * inside Nominatim's usage policy. Attribution is rendered with the results.
       */
      async searchNearby() {
        if (this.geoBusy) return;
        const q = (this.searchInput ? this.searchInput.value : '').trim();
        if (!q) { this.clearProximity(false); return; }
        if (!this.cfg.geocode) return;

        this.setBusy(true);
        this.setStatus(this.cfg.t.searching);
        try {
          const url = new URL('https://nominatim.openstreetmap.org/search');
          url.searchParams.set('format', 'json');
          url.searchParams.set('limit', '1');
          url.searchParams.set('q', q);
          if (this.cfg.bias) url.searchParams.set('countrycodes', this.cfg.bias);
          const lang = document.documentElement.lang;
          if (lang) url.searchParams.set('accept-language', lang);

          const res = await fetch(url.toString(), { headers: { Accept: 'application/json' } });
          if (!res.ok) throw new Error('HTTP ' + res.status);
          const hits = await res.json();
          if (!hits.length) { this.setStatus(this.cfg.t.failed, 'error'); return; }

          const hit = hits[0];
          const lat = parseFloat(hit.lat), lng = parseFloat(hit.lon);
          if (!Number.isFinite(lat) || !Number.isFinite(lng)) { this.setStatus(this.cfg.t.failed, 'error'); return; }
          this.applyProximity({ lat, lng }, (hit.display_name || q).split(',')[0].trim(), true);
        } catch (err) {
          this.setStatus(this.cfg.t.failed, 'error');
        } finally {
          this.setBusy(false);
        }
      }

      placeOriginMarker() {
        this.removeOriginMarker();
        if (!this.map || !this.origin || !window.L) return;
        this.originMarker = window.L.circleMarker([this.origin.lat, this.origin.lng], {
          radius: 8, color: '#ffffff', weight: 3, fillColor: '#1a73e8', fillOpacity: 1
        }).addTo(this.map);
      }

      removeOriginMarker() {
        if (this.originMarker) { this.originMarker.remove(); this.originMarker = null; }
      }

      loadLeaflet() {
        if (window.L) return Promise.resolve();
        return new Promise((resolve, reject) => {
          const css = document.createElement('link');
          css.rel = 'stylesheet';
          css.href = 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.9.4/leaflet.min.css';
          document.head.appendChild(css);
          const script = document.createElement('script');
          script.src = 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.9.4/leaflet.min.js';
          script.onload = resolve;
          script.onerror = reject;
          document.head.appendChild(script);
        });
      }

      async toggleMap() {
        if (!this.mapEl) return;
        if (this.map) {
          this.mapEl.hidden = !this.mapEl.hidden;
          if (this.mapBtn) this.mapBtn.textContent = this.mapEl.hidden ? this.showLabel : this.hideLabel;
          this.setMapBtnState(!this.mapEl.hidden);
          if (!this.mapEl.hidden) setTimeout(() => this.map.invalidateSize(), 50);
          return;
        }
        await this.loadLeaflet();
        this.mapEl.hidden = false;
        if (this.mapNote) this.mapNote.hidden = true;
        if (this.mapBtn) this.mapBtn.textContent = this.hideLabel;
        this.setMapBtnState(true);
        this.map = window.L.map(this.mapEl).setView([52.3, 5.2], 4);
        window.L.Icon.Default.imagePath = 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.9.4/images/';
        window.L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
          attribution: '&copy; OpenStreetMap',
          maxZoom: 18
        }).addTo(this.map);
        this.syncMarkers();
      }

      syncMarkers() {
        if (!this.map || !window.L) return;
        this.markers.forEach((m) => m.remove());
        this.markers = [];
        const bounds = [];
        this.cards.forEach((card) => {
          if (card.hidden) return;
          const lat = parseFloat(card.getAttribute('data-ehs-lat'));
          const lng = parseFloat(card.getAttribute('data-ehs-lng'));
          if (Number.isNaN(lat) || Number.isNaN(lng)) return;
          const marker = window.L.marker([lat, lng]).addTo(this.map);
          marker.bindPopup(this.buildPopup(card));
          marker.on('click', () => this.selectCard(card, false));
          this.markers.push(marker);
          card._ehsMarker = marker;
          bounds.push([lat, lng]);
        });
        // In proximity mode also plot, and frame, where the visitor searched from.
        if (this.origin) {
          this.placeOriginMarker();
          bounds.push([this.origin.lat, this.origin.lng]);
        }
        if (bounds.length) this.map.fitBounds(bounds, { padding: [24, 24], maxZoom: 8 });
      }

      /**
       * Popup content: name, address, distance (when ranked), then the card's own links.
       * Built with DOM APIs and clones of already-rendered nodes -- no innerHTML anywhere.
       */
      buildPopup(card) {
        const wrap = document.createElement('div');
        wrap.className = 'ehs-dealer-popup';

        const name = document.createElement('p');
        name.className = 'ehs-dealer-popup__name';
        name.textContent = card.getAttribute('data-ehs-name') || '';
        wrap.appendChild(name);

        const addr = card.querySelector('.ehs-dealer__address');
        if (addr) {
          const a = document.createElement('p');
          a.className = 'ehs-dealer-popup__address';
          a.textContent = addr.textContent.replace(/\s*\n\s*/g, '\n').trim();
          wrap.appendChild(a);
        }

        if (typeof card._km === 'number') {
          const dEl = document.createElement('p');
          dEl.className = 'ehs-dealer-popup__distance';
          dEl.textContent = this.cfg.t.dist.replace('{distance}', this.formatDistance(card._km));
          wrap.appendChild(dEl);
        }

        const links = card.querySelector('.ehs-dealer__links');
        if (links) {
          const l = document.createElement('p');
          l.className = 'ehs-dealer-popup__links';
          links.querySelectorAll('a').forEach((a) => l.appendChild(a.cloneNode(true)));
          if (l.childNodes.length) wrap.appendChild(l);
        }
        return wrap;
      }

      selectCard(card, pan = true) {
        this.cards.forEach((c) => c.classList.toggle('is-active', c === card));
        card.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
        if (pan && card._ehsMarker && this.map) {
          this.map.setView(card._ehsMarker.getLatLng(), Math.max(this.map.getZoom(), 8));
          card._ehsMarker.openPopup();
        }
      }
    }
  );

  } catch(e) { console.error(e); }
})();
})();
